import { OwlResponse } from '../../types';
import { UserTrackingPayload } from '../../types/owl';
import { AbstractClient } from './AbstractClient';

export class TrackingClient extends AbstractClient {
  agentLinkVisit = this.createPayloadHandler<
    OwlResponse<never>,
    {
      payload: UserTrackingPayload;
    }
  >('POST', () => '/agent-link-visit');
}
